<div class="content-card">
  <alert message="StatementsAlert" alertType="info"></alert>

  @for (statementFormTypeId of statementFormTypeIds; track statementFormTypeId) {
    <app-statement-form
      [statementFormTypeId]="statementFormTypeId"
      [formQuestions]="formQuestions[statementFormTypeId]"
      [fileInfoList]="fileInfoList"
      [files]="files"
      [savedStatements]="savedStatements"
      [workerFormId]="workerFormId"
      [workerId]="workerId"
      [workerStatements]="workerStatements"
      [workerFileTypes]="workerFileTypes | async"
      [isFormDisabled]="isFormDisabled()"
      (statementChange)="onStatementChanged($event)"
    ></app-statement-form>
  }

  <div class="header-wrapper"></div>

  @for (clause of ppkClauses$ | async; track clause) {
    <div fxLayout="row">
      <a [href]="clause.File" target="_blank" rel="noopener noreferrer">{{ clause.Name }}</a>
    </div>
  }

  @if (formQuestions) {
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20 buttons">
      <button mat-raised-button color="accent" [disabled]="!canProceed" matStepperPrevious>
        {{ 'Back' | translate }}
      </button>
      @if (!isRequestPending) {
        <button
          mat-raised-button
          color="primary"
          [disabled]="!canProceed"
          (click)="!isRequestPending && submitStatements(false)"
          >
          {{ 'Next' | translate }}
        </button>
      }
    </div>
  }
</div>
